import React from 'react';
import { FileIcon } from 'elements/Icon';

const Audio = () => (
  <FileIcon>
    <path d="M98,2v136H2V2L98,2 M100,0H0v140h100V0L100,0z" />
    <path d="M55.034,55.759c-1.116-0.757-2.646-0.644-3.634,0.346l-9.064,9.063H27.739c-2.514,0-4.552,2.038-4.552,4.552v10.701
      c0,2.513,2.038,4.552,4.552,4.552h14.596l9.064,9.064c0.988,0.988,2.518,1.101,3.634,0.346L55.034,55.759L55.034,55.759z"/>
<path d="M64.168,75.305c0,4.59-2.284,8.642-5.77,11.1l2.504,2.505c4.113-3.124,6.777-8.055,6.777-13.605
      c0-5.551-2.666-10.482-6.777-13.606l-2.504,2.505C61.884,66.663,64.168,70.715,64.168,75.305z"/>
<path d="M73.301,75.305c0,7.058-3.571,13.292-8.997,17.006l2.519,2.52c6.047-4.386,9.99-11.501,9.99-19.526
      s-3.943-15.141-9.99-19.526l-2.519,2.519C69.73,62.013,73.301,68.247,73.301,75.305z"/>
  </FileIcon>
);

export default Audio;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/types/Audio.jsx